<template>
  <div>
    <header>
      <navbar id="navbar"/>
    </header>
    <main>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
      <tabBar></tabBar>
    </main>
    <footer>
      <MunFooter id="munFooter"/>
    </footer>
    <!-- <rewards></rewards> -->
  </div>
</template>

<script>
import Navbar from "@/components/navbar";
import MunFooter from "@/components/munFooter";
import Rewards from "../components/rewards";
import tabBar from "../components/tabBar";
import {mapActions, mapMutations, mapState} from 'vuex';
import { getToken } from "../common";
import {isUserAuthenticated} from "../store/modules/cart";

export default {
  name: "index",
  components: {
    Rewards,
    MunFooter,
    Navbar,
    tabBar,
  },
  methods:{
    ...mapActions('auth', ['fetchUserPermission']),
  },
  beforeMount:function() {
    if(!isUserAuthenticated()) {
      this.$router.push(`/login`);
    } else {
      this.fetchUserPermission(`fetchUserPermission`, getToken());
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/view/index.vue